"use client";

import React from "react";
import styles from "./CrmSolutionsServicesCardSection.module.css";
import ServiceCard from "../../components/ServiceCard";
import crmServicesData from "../../data/crm-solutions";
import { useServiceData } from "../../hooks/useServiceData";

export default function CrmSolutionsServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;

  // Use backend data if available, otherwise fallback to static data
  const displayData = services?.items || crmServicesData;
  const sectionTitle = services?.title || "CRM SOLUTIONS";
  const sectionSubtitle = services?.subtitle || "CRM Services We Provide";

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="text-center mb-4" data-reveal="slide-up">
          <div className={styles.eyebrow}>{sectionTitle}</div>
          <h2 className={styles.title}>{sectionSubtitle}</h2>
        </div>
        <div className="row g-3 g-md-4" data-reveal="stagger-up">
          {displayData.map((card, idx) => (
            <div className="col-12 col-md-6 col-lg-4" key={idx}>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets}
                tags={card.tags} // Backend uses 'tags'
                minHeight={card.minHeight || 400}
                accent="#F48428"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
